export const SHOW_SLIDE_PANEL = '|A|SlidePanel.SHOW_SLIDE_PANEL'
export const HIDE_SLIDE_PANEL = 'SlidePanel.HIDE_SLIDE_PANEL'

export const showSlidePanel = () => ({ type: SHOW_SLIDE_PANEL })
export const hideSlidePanel = () => ({ type: HIDE_SLIDE_PANEL })
